export default {
  spritesDir: 'assets/sprites/'
};



// WEBPACK FOOTER //
// ./src/settings/general.js